export const keyAuthorization = 'auth' //sessionStorage
export const keyUserFullName = 'userFullName'
export const keyUserId = 'userId'
export const keyTenant = 'tenant'
export const keyTenantInfo = 'tenantInfo'
export const ratingHashGroup = 'ratingHashGroup'
export const keyUserRole = 'userRole'
export const keySelectedStore = 'selectedStore'